import React from 'react';
import Auth from '../Auth';
import axios from '../axios';

const ImpersonationBanner = () => {
    const impersonationData = Auth.getImpersonationData();

    if (!impersonationData) {
        return null;
    }

    const handleStopImpersonation = async () => {
        try {
            const response = await axios.post('admin/stop-impersonation');

            if (response.data.success) {
                Auth.setToken(response.data.data.token);
                Auth.setUser(response.data.data.user);
                Auth.stopImpersonation();

                window.location.href = '/store/accounts';
            }
        } catch (error) {
            console.error('Failed to stop impersonation:', error);
        }
    };

    return (
        <>
            {/* Spacer so the fixed banner doesn't overlap the navbar */}
            <div style={{ height: 44 }} />
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                backgroundColor: '#1a6b9a',
                color: '#fff',
                padding: '8px 20px',
                zIndex: 9999,
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: 13,
                fontWeight: 500,
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <span>
                        👤 Impersonating: <strong>{impersonationData.impersonated_account.Code}</strong> — {impersonationData.impersonated_account.Name}
                    </span>
                    <span style={{ opacity: 0.75, fontSize: 12 }}>
                        (as {impersonationData.original_admin.name})
                    </span>
                </div>
                <button
                    onClick={handleStopImpersonation}
                    style={{
                        backgroundColor: '#fff',
                        color: '#1a6b9a',
                        border: 'none',
                        padding: '4px 14px',
                        borderRadius: 4,
                        fontWeight: 600,
                        cursor: 'pointer',
                        fontSize: 13,
                    }}
                >
                    Stop Impersonation
                </button>
            </div>
        </>
    );
};

export default ImpersonationBanner;
